import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageComponent } from '@app/v2/components/page/page.component';
import { SitesComponent } from '@app/v2/components/sites/sites.component';

@Component({
    selector: 'medpace-sites.page',
    imports: [PageComponent, SitesComponent],
    templateUrl: './sites.page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SitesPageComponent {}
